// Custom VFG components
// ClearFix.vue
<template>
  <div class="clearfix">
  </div>
</template>
 
<script>
    export default {
        props: ['text'],
        name: 'clearfix',
        mixins: [VueFormGenerator.abstractField],
        methods: {

        },
        data() {
            return {}
        }
    }
</script>

<style>
   .field-clearfix  {
        height: 0px;
        margin-bottom: 0px !important;
    }
</style>
